import axios from "axios";
import { env } from "../environment";

/**
 * Dedicated, standalone "enter" call for the /deep-insights-chat/dev/playground
 * model/engine comparison page. No credentials any more — access is gated
 * purely by the backend's ENABLE_DEV_DEMO flag (see
 * app/routers/dev_playground.py), which 404s this route when unset.
 */
export async function devPlaygroundEnter() {
  try {
    const response = await axios.get(`${env.deepInsightsURL}/dev-playground/enter`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

/**
 * Batch (non-streaming) TTS preview call for the blocked/batch-only engines
 * (eleven_v3/v4/v4_turbo, gemini_tts) — see
 * app/routers/dev_playground.py:tts_preview. Returns base64 audio + mime
 * type; never used by the live voice overlay.
 */
export async function devPlaygroundTtsPreview(token, text, modelId) {
  try {
    const authScheme = "Bearer";
    const authHeaderValue = authScheme + " " + token;
    const response = await axios.post(
      `${env.deepInsightsURL}/dev-playground/tts-preview`,
      { text, model_id: modelId },
      { headers: { Authorization: authHeaderValue } }
    );
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

/**
 * Batch (non-streaming) STT preview for each provider's whole-file-only
 * model(s) (scribe_v2/scribe_v2_medical, Gemini's batch transcribe model) —
 * see app/routers/dev_playground.py:stt_preview. Uploads one recorded clip
 * and waits for the full transcript; never used by the live voice overlay.
 */
export async function devPlaygroundSttPreview(token, audioBlob, modelId) {
  try {
    const authScheme = "Bearer";
    const authHeaderValue = authScheme + " " + token;
    const formData = new FormData();
    formData.append("model_id", modelId);
    formData.append("file", audioBlob, "clip.webm");
    const response = await axios.post(
      `${env.deepInsightsURL}/dev-playground/stt-preview`,
      formData,
      { headers: { Authorization: authHeaderValue, "Content-Type": "multipart/form-data" } }
    );
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}
